export default __webpack_public_path__ + "static/0063-8eb35da7e024d4704e5dd4f564226007.png";